<div class="modal-header">
    <h3 class="dialog-title text-center">{{'Calibration Variability Exceeded' | translate}}</h3>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <h5 class="d-flex justify-content-center text-center fs-16 text-bold">
                {{'This sample\'s calibration variability of {{calVariability}}% exceeds the configured maximum cal drift of {{maxCalDrift}}%.' | translate:{ calVariability: data.calVariabilityPercent | number:'1.0-2', maxCalDrift: data.maxCalDriftPercent | number:'1.0-2' } }}
            </h5>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <p class="d-flex justify-content-center text-center">
                {{'Do you want to continue with the status change or void the sample?' | translate}}
            </p>
        </div>
    </div>

    <div mat-dialog-actions class="createButton mt-2">
        <button class="btn save-modal-btn w-50" (click)="onContinue()">{{'Continue' | translate}}</button>
        <button class="btn cancel-modal-btn w-50" (click)="onVoid()">{{'Void' | translate}}</button>
    </div>
</div>
